import { AppState } from 'store/store';

export const getPasswordSecurity = (state: AppState) => state.passwordSecurity;
